import * as z from "zod";

export const SupplierStatusEnum = z.enum([
  "active",
  "inactive",
  "pending_approval",
  "suspended",
]);

export const SupplierSchema = z.object({
  id: z.string().uuid(),
  company_id: z.string().uuid(),
  type: z.string().optional(), // Can store multiple types as comma-separated or JSON
  supplier_code: z
    .string()
    .max(100, "Supplier code must be less than 100 characters")
    .optional(),
  status: SupplierStatusEnum.default("active"),
  notes: z.string().optional(),
  created: z
    .date()
    .optional()
    .default(() => new Date()),
  updated: z
    .date()
    .optional()
    .default(() => new Date()),
});

export const createSupplierSchema = SupplierSchema.omit({
  id: true,
  created: true,
  updated: true,
});

export const updateSupplierSchema = SupplierSchema.partial().omit({
  id: true,
  created: true,
  updated: true,
});

// Supplier product pricing schema
export const SupplierProductSchema = z.object({
  id: z.string().uuid().optional(),
  supplier_id: z.string().uuid(),
  product_id: z.string().uuid(),
  supplier_product_code: z
    .string()
    .max(100, "Supplier product code must be less than 100 characters")
    .nullable()
    .optional(),
  unit_price: z
    .number()
    .min(0, "Unit price cannot be negative")
    .multipleOf(0.01, "Unit price must have at most 2 decimal places")
    .nullable()
    .optional(),
  minimum_quantity: z
    .number()
    .int("Minimum quantity must be a whole number")
    .min(0, "Minimum quantity cannot be negative")
    .nullable()
    .optional(),
  lead_time_days: z
    .number()
    .int("Lead time days must be a whole number")
    .min(0, "Lead time days cannot be negative")
    .nullable()
    .optional(),
  is_preferred: z.boolean().default(false),
});

export const createSupplierProductSchema = SupplierProductSchema.omit({
  id: true,
});

// Type exports
export type CreateSupplierInput = z.infer<typeof createSupplierSchema>;
export type UpdateSupplierInput = z.infer<typeof updateSupplierSchema>;
